import { render, staticRenderFns } from "./friendchain.vue?vue&type=template&id=187baf36&scoped=true&"
import script from "./friendchain.vue?vue&type=script&lang=js&"
export * from "./friendchain.vue?vue&type=script&lang=js&"
import style0 from "./friendchain.vue?vue&type=style&index=0&id=187baf36&lang=stylus&scoped=true&"
import style1 from "./friendchain.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187baf36",
  null
  
)

component.options.__file = "friendchain.vue"
export default component.exports